import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Container } from 'reactstrap';
import { isLoggedIn } from '../../services';
import { getLastConnectedUser } from '../../redux/modules/auth';
import MainContent from './MainContent/MainContent';
import Login from '../../containers/Login/Login';
import Nav from './Nav/Nav';

import './App.css';

const App = () => {
    const { user } = useSelector(state => state.auth);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLastConnectedUser());
    }, []);

    const theme = "light";

    //if (isLoggedIn()) {
        return (
            <div className={`App ${theme}-app`}>
                <Container fluid>
                    <Nav/>
                    <MainContent />
                </Container>
            </div>
        );
    //};

    //return <Login />;
}

export default App;
